import { tokens } from 'src/design-system';

export const AnalyticsViewStyles = (theme) => ({
  interSectDiv: {
    minHeight: '100px',
  },
  priceTrendsHeaderDiv: {
    padding: '5px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
  priceTrendsHeading: {
    fontWeight: tokens.fontWeight.semibold,
  },
});

export const PRICE_TREND_COLORS = {
  MINIMUM_PRICE: '#CA2424',
  MAXIMUM_PRICE: '#60A249',
  AVERAGE_PRICE: '#3F87DB',
};
